import React from 'react';
import { Link } from 'react-router-dom';

import { List, ListItem, IconButton, Typography } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { StyledLink } from '../Components';
import { GetGuideQuery } from '../__generated__/graphql';
import { Unpacked } from '../graphQLTypes/types';
import { StyledPaper } from '../theme';
import { Guide } from './Details';

type Standard = Unpacked<NonNullable<GetGuideQuery['guide']>['standards']>;
export function Standards({ guide, elevation }: { guide: Guide; elevation?: number }) {
  const standards = guide.standards ?? [];
  const cmsStandards = guide.cmsStandards ?? [];
  return (
    <StyledPaper elevation={elevation}>
      <Typography variant="h6" component="h3">
        Standarder&nbsp;
        <IconButton component={Link} to={`/guide/standards/${guide.id}`} size="large">
          <Edit />
        </IconButton>
      </Typography>
      {standards.length === 0 && (
        <Typography variant="subtitle1" color="textSecondary">
          Ingen angitt
        </Typography>
      )}
      <List dense>
        {standards.map((x) => {
          if (!x) return null;
          return (
            <ListItem key={x.id}>
              <StyledLink to={`/standard/${x.id}`}>
                <Typography noWrap>{x.name}</Typography>
              </StyledLink>
            </ListItem>
          );
        })}
      </List>
      {guide.useCmsContent && (
        <>
          <Typography variant="h6" component="h3">
            Standarder definert i CMS
          </Typography>
          {cmsStandards.length === 0 && (
            <Typography variant="subtitle1" color="textSecondary">
              Ingen angitt
            </Typography>
          )}
          <List dense>
            {cmsStandards.map((x) => {
              if (!x) return null;
              return (
                <ListItem key={x.id}>
                  <StyledLink to={`/standard/${x.id}`}>
                    <Typography noWrap>{x.name}</Typography>
                  </StyledLink>
                </ListItem>
              );
            })}
          </List>
        </>
      )}
    </StyledPaper>
  );
}
